import * as React from 'react';
export const BTSvg = React.forwardRef(function BTSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement(
        'g',
        null,
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FCD669',
          d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#A68527',
          fillOpacity: 0.1,
          fillRule: 'nonzero',
          d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2ZM1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#E25950',
          d: 'M2 14c-.51 0-.975-.19-1.328-.504L15.328 2.504c.412.367.672.9.672 1.496v8a2 2 0 0 1-2 2H2Z',
        }),
      ),
      /*#__PURE__*/ React.createElement('path', {
        stroke: '#FFF',
        strokeLinecap: 'square',
        strokeWidth: 2,
        d: 'M5 10h2V8h2V6h2',
      }),
    ),
  );
});
BTSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var BT = {
  category: 'flag',
  colorable: false,
  name: 'BT',
  svg: BTSvg,
};
